/**
 * TurnedWizard - Ultimate Hogwarts Sorting Quiz Logic
 * Super Harry Potter Fan Edition - Figma Inspired
 */

(function() {
  const wizardQuiz = {
    currentQuestion: 0,
    scores: { gryffindor: 0, slytherin: 0, ravenclaw: 0, hufflepuff: 0 },
    questions: [
      {
        text: "Which of these traits do you value most in an artist?",
        options: [
          { text: "Bold strokes and courageous experimentation", points: { gryffindor: 5 } },
          { text: "Meticulous detail and sharp intellectual vision", points: { ravenclaw: 5 } },
          { text: "Ambitious scale and resourceful technique", points: { slytherin: 5 } },
          { text: "Consistent dedication and a helpful spirit", points: { hufflepuff: 5 } }
        ]
      },
      {
        text: "TRIVIA: Which founder's heirloom was a diadem said to grant wisdom?",
        options: [
          { text: "Salazar Slytherin", points: { slytherin: 2 } },
          { text: "Rowena Ravenclaw", points: { ravenclaw: 10 } },
          { text: "Godric Gryffindor", points: { gryffindor: 2 } },
          { text: "Helga Hufflepuff", points: { hufflepuff: 2 } }
        ]
      },
      {
        text: "You're painting a masterpiece. What is your 'Magical Secret'?",
        options: [
          { text: "A hidden map within the brushstrokes", points: { gryffindor: 3, ravenclaw: 2 } },
          { text: "Pigments made from crushed dragon scales", points: { slytherin: 5 } },
          { text: "A charm that makes the portrait whisper", points: { ravenclaw: 5 } },
          { text: "Light that only glows for true friends", points: { hufflepuff: 5 } }
        ]
      },
      {
        text: "TRIVIA: What color is the spark that shoots from a wand during 'Expelliarmus'?",
        options: [
          { text: "Green", points: { slytherin: 5 } },
          { text: "Blue", points: { ravenclaw: 2 } },
          { text: "Scarlet", points: { gryffindor: 10 } },
          { text: "Yellow", points: { hufflepuff: 2 } }
        ]
      },
      {
        text: "How do you handle a creative block?",
        options: [
          { text: "Charge through it with pure energy", points: { gryffindor: 5 } },
          { text: "Research ancient techniques for hours", points: { ravenclaw: 5 } },
          { text: "Find a clever shortcut or new tool", points: { slytherin: 5 } },
          { text: "Collaborate with fellow wizards", points: { hufflepuff: 5 } }
        ]
      },
      {
        text: "TRIVIA: Which house's ghost is known as the Grey Lady?",
        options: [
          { text: "Ravenclaw", points: { ravenclaw: 10 } },
          { text: "Slytherin", points: { slytherin: 1 } },
          { text: "Gryffindor", points: { gryffindor: 1 } },
          { text: "Hufflepuff", points: { hufflepuff: 1 } }
        ]
      },
      {
        text: "Where is your ideal studio located?",
        options: [
          { text: "At the top of the highest tower", points: { ravenclaw: 5 } },
          { text: "In a cozy room near the kitchens", points: { hufflepuff: 5 } },
          { text: "Deep in the dungeons for total focus", points: { slytherin: 5 } },
          { text: "In a room that only appears when needed", points: { gryffindor: 5 } }
        ]
      },
      {
        text: "TRIVIA: What animal is on the Hufflepuff crest?",
        options: [
          { text: "Beaver", points: { hufflepuff: 1 } },
          { text: "Badger", points: { hufflepuff: 10 } },
          { text: "Bear", points: { hufflepuff: 1 } },
          { text: "Bumblebee", points: { hufflepuff: 1 } }
        ]
      },
      {
        text: "What is your primary motivation for creating art?",
        options: [
          { text: "To leave a legendary legacy", points: { slytherin: 5 } },
          { text: "To uncover universal truths", points: { ravenclaw: 5 } },
          { text: "To inspire courage in others", points: { gryffindor: 5 } },
          { text: "To bring joy to my fellowship", points: { hufflepuff: 5 } }
        ]
      },
      {
        text: "TRIVIA: Who was the Head of Slytherin House during Harry's first six years?",
        options: [
          { text: "Severus Snape", points: { slytherin: 10 } },
          { text: "Horace Slughorn", points: { slytherin: 5 } },
          { text: "Lucius Malfoy", points: { slytherin: 1 } },
          { text: "Tom Riddle", points: { slytherin: 1 } }
        ]
      }
    ],

    init() {
      this.bindEvents();
      this.checkStoredHouse();
    },

    bindEvents() {
      document.addEventListener('click', (e) => {
        if (e.target.matches('.tw-quiz-option')) {
          this.handleOptionClick(e.target);
        }
        if (e.target.matches('.tw-quiz-close')) {
          this.closeModal();
        }
        if (e.target.matches('.tw-quiz-trigger')) {
          this.openModal();
        }
        if (e.target.matches('.tw-quiz-restart')) {
          this.restartQuiz();
        }
      });
    },

    openModal() {
      const modal = document.getElementById('tw-quiz-modal');
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
        this.renderQuestion();
      }
    },

    closeModal() {
      const modal = document.getElementById('tw-quiz-modal');
      if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    },

    handleOptionClick(btn) {
      const qIdx = parseInt(btn.dataset.question);
      const oIdx = parseInt(btn.dataset.option);
      const points = this.questions[qIdx].options[oIdx].points;

      for (let house in points) {
        this.scores[house] += points[house];
      }

      this.currentQuestion++;

      if (this.currentQuestion < this.questions.length) {
        this.renderQuestion();
      } else {
        this.showResult();
      }
    },

    renderQuestion() {
      const container = document.getElementById('tw-quiz-content');
      if (!container) return;

      const q = this.questions[this.currentQuestion];
      const progress = ((this.currentQuestion) / this.questions.length) * 100;

      container.innerHTML = `
        <div class="tw-quiz-step">
          <div class="tw-quiz-progress-bar">
            <div class="tw-quiz-progress-fill" style="width: ${progress}%"></div>
          </div>
          <p class="tw-quiz-q-num">Ceremony Progress: ${Math.round(progress)}%</p>
          <h2 class="tw-quiz-question">${q.text}</h2>
          <div class="tw-quiz-options">
            ${q.options.map((o, i) => `
              <button class="tw-quiz-option" data-question="${this.currentQuestion}" data-option="${i}">
                ${o.text}
              </button>
            `).join('')}
          </div>
        </div>
      `;
    },

    showResult() {
      const container = document.getElementById('tw-quiz-content');
      if (!container) return;

      // Find winner
      let winner = 'gryffindor';
      let maxScore = -1;
      for (let house in this.scores) {
        if (this.scores[house] > maxScore) {
          maxScore = this.scores[house];
          winner = house;
        }
      }

      const houseInfo = {
        gryffindor: { 
          name: 'Gryffindor', 
          icon: '🦁', 
          color: '#740001', 
          gradient: 'from-red-900 to-red-700',
          quote: 'It is our choices that show what we truly are, far more than our abilities.',
          author: 'Albus Dumbledore'
        },
        slytherin: { 
          name: 'Slytherin', 
          icon: '🐍', 
          color: '#1a472a', 
          gradient: 'from-emerald-950 to-emerald-800',
          quote: 'Greatness inspires envy, envy engenders spite, spite spawns lies.',
          author: 'Lord Voldemort'
        },
        ravenclaw: { 
          name: 'Ravenclaw', 
          icon: '🦅', 
          color: '#0e1a40', 
          gradient: 'from-blue-950 to-blue-800',
          quote: 'Wit beyond measure is man\'s greatest treasure.',
          author: 'Rowena Ravenclaw'
        },
        hufflepuff: { 
          name: 'Hufflepuff', 
          icon: '🦡', 
          color: '#ecb939', 
          gradient: 'from-amber-700 to-amber-500',
          quote: 'I\'ll teach the lot, and treat them just the same.',
          author: 'Helga Hufflepuff'
        }
      };

      const result = houseInfo[winner];
      localStorage.setItem('wizardHouse', result.name);

      // Figma Inspired Result UI
      container.innerHTML = `
        <div class="tw-quiz-result">
          <div class="tw-hat-animation" style="font-size: 5rem;">🧙‍♂️</div>
          <p class="tw-quiz-hat-talk">"I know just what to do with you..."</p>
          
          <div class="tw-result-card" style="background: linear-gradient(135deg, #000, ${result.color}44); border: 2px solid ${result.color}; padding: 2rem; border-radius: 1rem; margin: 2rem 0; box-shadow: 0 0 30px ${result.color}33;">
            <h2 class="tw-quiz-house-name" style="color: ${result.color === '#ecb939' ? '#fcd34d' : '#fff'}; margin: 0;">${result.name}!</h2>
            <div class="tw-quiz-house-icon" style="font-size: 4rem; margin: 1rem 0;">${result.icon}</div>
            
            <div class="tw-loyalty-badge" style="background: ${result.color}; color: #fff; padding: 0.5rem 1rem; border-radius: 9999px; display: inline-flex; align-items: center; gap: 0.5rem; margin-bottom: 1.5rem; font-family: var(--font-heading); font-size: 0.8rem; border: 1px solid rgba(255,255,255,0.3);">
              <span>⭐ OATH OF LOYALTY</span>
            </div>

            <div style="background: rgba(0,0,0,0.5); padding: 1.5rem; border-radius: 0.5rem; border: 1px solid rgba(255,255,255,0.1); text-align: left;">
              <p style="font-style: italic; color: #eee; margin: 0; font-size: 1rem; line-height: 1.5;">"${result.quote}"</p>
              <p style="color: var(--tw-amber-500); font-size: 0.8rem; margin-top: 0.5rem; text-align: right;">— ${result.author}</p>
            </div>
          </div>

          <div class="tw-quiz-actions" style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
            <button class="tw-cta-button tw-quiz-restart" style="background: var(--tw-zinc-900); border: 1px solid var(--tw-amber-800);">Resort</button>
            <a href="/pages/house-${winner}" class="tw-cta-button" style="background: ${result.color}; text-decoration: none; color: #fff;">Common Room</a>
          </div>
        </div>
      `;

      // Dispatch global event for other widgets to react
      document.dispatchEvent(new CustomEvent('wizardHouseSorted', { detail: { house: result.name, color: result.color, icon: result.icon } }));
    },

    restartQuiz() {
      this.currentQuestion = 0;
      this.scores = { gryffindor: 0, slytherin: 0, ravenclaw: 0, hufflepuff: 0 };
      this.renderQuestion();
    },

    checkStoredHouse() {
      const house = localStorage.getItem('wizardHouse');
      if (house) {
        // Small delay to ensure other components are ready
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('wizardHouseSorted', { detail: { house: house } }));
        }, 100);
      }
    }
  };

  window.wizardQuiz = wizardQuiz;
  document.addEventListener('DOMContentLoaded', () => wizardQuiz.init());
})();
